module.exports = __webpack_public_path__ + "img/img1_zhTc.9824d225.png";